import React from "react";
import { View, StyleSheet } from "react-native";
import NtTouchableEffect from "../../components/NtTouchableEffect";
import NtText from "../../components/NtText";
import Logger from "../../common/utils/Logger";
import colors from "../../config/colors";
import { parseAccountAlias } from "../../common/utils/ControllerUtils";
import NtMaterialIcon from "../../components/NtMaterialIcon";

function NtDashboardItem({ containerStyle, item, onPress }) {
  const renderAlias = () => {
    return (
      <View style={{ alignItems: "flex-start" }}>
        <View
          style={{
            backgroundColor: "#12ABFF",
            borderRadius: 15,
            paddingRight: 6,
            paddingTop: 3,
            paddingBottom: 3,
            paddingLeft: 6,
          }}
        >
          <NtText style={{ flex: 1, color: "white", fontWeight: "600" }}>
            {parseAccountAlias(item.alias)}
          </NtText>
        </View>
      </View>
    );
  };
  return (
    <NtTouchableEffect
      style={[styles.container, containerStyle]}
      onPress={onPress}
    >
      <View style={{ flexDirection: "row" }}>
        <View style={{}}>
          {renderAlias()}

          <View style={{ marginTop: 20 }}>
            <NtText>Plan</NtText>
            <NtText style={{ flex: 1 }}>
              {item._embedded?.group?.label}, {item._embedded?.group?.id}
            </NtText>
          </View>

          <NtText style={{ flex: 1 }}> ${item.credit}</NtText>
        </View>
      </View>
    </NtTouchableEffect>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 15,
    backgroundColor: colors.lighestGray,
    marginRight: 10,
    borderRadius: 10,
  },
});

export default NtDashboardItem;
